(function(){
    let comment_form = document.querySelector("#comment_form");
    let email_form = document.querySelector("#email_form");
    let btnSubmit = document.querySelector("#btnSubmit");
    let ulMain = document.querySelector(".ul-main");
    let response_form = document.querySelector("#response_form");
    let _url_path = document.querySelector("#_url_path").value;

    email_form.value = "";
    comment_form.value = "";
    let isResponse = false;
    var id = '';
    response_form.hidden = true;

    const strip = (string) => {
        let word = "";
        for (let i = 0; i < string.length; i++) {
            word += string[i].replace(
                /[^\w\s\x.,;¿!¡ñáéíóú@\x3F\x2B\x2D\x28\x29]/g,
                " "
            );
        }
        return word;
    };

    btnSubmit.addEventListener("click", (e) => {
        e.preventDefault();
        if (!isResponse) {
            makePost(null);
        } else {
            makePost(id)
        }
    });

    ulMain.addEventListener('click', (e) => {
        if (e.target.classList.contains('comment')) {
            id = e.target.getAttribute('id');
            const small = e.target.parentElement;
            responseText(small.firstChild.textContent);
            document.getElementById("comment_form").focus();
        }
    });

    const responseText = (quote) => {
        document.querySelector("#label_form").innerText = `Responderás el comentario: `;
        response_form.hidden = false
        response_form.innerText = `"${quote.trim()}: "`;
        isResponse = true;
    };

    const makePost = (id) => {
        const payload = {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify({
                url_path: _url_path,
                email: email_form.value,
                comment: strip(comment_form.value),
                last_update: "1980-01-01T01:01:01",
                response_comment: parseInt(isResponse ? id : '')
            }),
        };

        fetch("/api/v1/zinnia_s/sitecomment/", payload)
            .then((response) => {
                location.reload();
            })
            .catch((err) => {
                console.error(err);
            });
    };

}());